import { CALL_API, Schemas } from '../../../../common/middleware/api';

export const GOCARDLESS_ACCESS_TOKEN_REQUEST = 'GOCARDLESS_ACCESS_TOKEN_REQUEST';
export const GOCARDLESS_ACCESS_TOKEN_SUCCESS = 'GOCARDLESS_ACCESS_TOKEN_SUCCESS';
export const GOCARDLESS_ACCESS_TOKEN_FAILURE = 'GOCARDLESS_ACCESS_TOKEN_FAILURE';

export const GOCARDLESS_REVOKE_ACCESS_TOKEN_REQUEST = 'GOCARDLESS_REVOKE_ACCESS_TOKEN_REQUEST';
export const GOCARDLESS_REVOKE_ACCESS_TOKEN_SUCCESS = 'GOCARDLESS_REVOKE_ACCESS_TOKEN_SUCCESS';
export const GOCARDLESS_REVOKE_ACCESS_TOKEN_FAILURE = 'GOCARDLESS_REVOKE_ACCESS_TOKEN_FAILURE';

export const GOCARDLESS_VERIFICATION_STATUS_REQUEST = 'GOCARDLESS_VERIFICATION_STATUS_REQUEST';
export const GOCARDLESS_VERIFICATION_STATUS_SUCCESS = 'GOCARDLESS_VERIFICATION_STATUS_SUCCESS';
export const GOCARDLESS_VERIFICATION_STATUS_FAILURE = 'GOCARDLESS_VERIFICATION_STATUS_FAILURE';

export const requestAccessToken = ({ code, paymentConfigurationId, useSandbox }, onSuccess, onError) => ({
	[CALL_API]: {
		types: [GOCARDLESS_ACCESS_TOKEN_REQUEST, GOCARDLESS_ACCESS_TOKEN_SUCCESS, GOCARDLESS_ACCESS_TOKEN_FAILURE],
		endpoint: 'api/paymentMethods/GoCardless/oauth',
		method: 'POST',
		request: { code, paymentConfigurationId, useSandbox },
		onSuccessEvent: onSuccess,
		onErrorEvent: onError
	}
});

export const revokeAccessToken = ({ paymentConfigurationId }, onSuccess, onError) => ({
	[CALL_API]: {
		types: [GOCARDLESS_REVOKE_ACCESS_TOKEN_REQUEST, GOCARDLESS_REVOKE_ACCESS_TOKEN_SUCCESS, GOCARDLESS_REVOKE_ACCESS_TOKEN_FAILURE],
		endpoint: 'api/paymentMethods/GoCardless/oauth/revoke',
		method: 'POST',
		request: { paymentConfigurationId },
		onSuccessEvent: onSuccess,
		onErrorEvent: onError
	}
});

export const checkVerificationStatus = ({ paymentConfigurationId }, onSuccess, onError) => ({
	[CALL_API]: {
		types: [GOCARDLESS_VERIFICATION_STATUS_REQUEST, GOCARDLESS_VERIFICATION_STATUS_SUCCESS, GOCARDLESS_VERIFICATION_STATUS_FAILURE],
		endpoint: 'api/paymentMethods/GoCardless/oauth/verify',
		method: 'POST',
		request: { paymentConfigurationId },
		onSuccessEvent: onSuccess,
		onErrorEvent: onError
	}
});